import CardMediaSlider from "./card-media-slider";

export default CardMediaSlider;